import { ActiveBonus } from "../Bonuses/ActiveBonus";
import { BonusManager } from "../Bonuses/BonusManager";
import { eBonusUID } from "../Bonuses/Bonus";
import { Game, eTextureAsset } from "../../Game";
import { TIME } from "../Gameplay";
import { Character, eCharacterState } from "./Character";



export class Shield {
    private static readonly _SIZE = 0.5;
    private static readonly _OPACITY = 1;

    private _plChar: Character;
    private _entity: pc.Entity;
    private _bonus: ActiveBonus;

    /**
     * (RO) True, pokud je stit aktivni
     */
    get isActive(): boolean { return this._entity.enabled; }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(char: Character, charEntity: pc.Entity) {
        this._plChar = char;

        // Vytvorit pc.Entity pro stit
        let material = new pc.StandardMaterial();
        material.diffuse.set(0, 0, 0);
        material.opacity = 0.999;
        material.blendType = pc.BLEND_ADDITIVEALPHA;
        material.emissiveMap = Game.APP.assets.find(eTextureAsset.shield, pc.eAssetType.texture).resource as pc.Texture;
        material.emissiveMapTiling.set(2, 2);
        material.emissiveIntensity = 0.75;
        material.emissive.set(0, 0.3046, 0.6640);
        material.emissiveTint = true;
        material.specular.set(0, 0, 0);
        material.depthTest = false;
        material.depthWrite = false;
        material.update();

        this._entity = new pc.Entity();
        this._entity.addComponent(pc.eCompomentType.model, {
            type: pc.eModelType.sphere,
            castShadows: false,
            castShadowsLightmap: false,
            receiveShadows: false,
            material: material,
        });
        this._entity.setLocalScale(Shield._SIZE, Shield._SIZE, Shield._SIZE);
        this._entity.setLocalPosition(0, 0.15, 0);
        this._entity.enabled = false;
        charEntity.addChild(this._entity);

        // Zachytavat aktivaci a deaktivaci bonusu SHIELD
        BonusManager.instance.events.on(BonusManager.EVENT_BONUS_ACTIVATE + eBonusUID.shield, this.handleBonusActivation, this);
        BonusManager.instance.events.on(BonusManager.EVENT_BONUS_DEACTIVATE + eBonusUID.shield, this.handleBonusDeactivation, this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        if (this._entity.enabled)
            this._entity.enabled = false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (!this._entity.enabled)
            return;

        // Rotace
        let i = 90 * TIME.deltaS;

        this._entity.rotateLocal(i, 0, i);

        let bnsRemTime = this._bonus.remTime;
        let scale: number;

        if (bnsRemTime < 500) {
            // Plynule zmizeni
            let progress = pc.CubicOut((500 - bnsRemTime) / 500);

            scale = 1 + 0.5 * progress;
            this._entity.model.meshInstances[0].setParameter("material_opacity", Shield._OPACITY - Shield._OPACITY * progress);
        }
        else {
            let i1 = bnsRemTime / 200;
            let i2 = Math.floor(i1);
            i1 -= i2;

            if ((i2 & 1) == 0) {
                scale = Shield._SIZE + 0.05 * i1;
            }
            else {
                scale = Shield._SIZE + 0.05 - 0.05 * i1;
            }
        }

        this._entity.setLocalScale(scale, scale, scale);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleBonusActivation(bonus: ActiveBonus): void {
        if (this._plChar.state == eCharacterState.walk) {
            this._bonus = bonus;

            this._entity.setLocalScale(Shield._SIZE, Shield._SIZE, Shield._SIZE);
            this._entity.model.meshInstances[0].setParameter("material_opacity", Shield._OPACITY);
            this._entity.enabled = true;
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleBonusDeactivation(): void {
        this.reset();
    }
}